import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { tabularPropertiesCommonAdapts, TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';
import { SapOdpDataset } from 'app/model/dataset/sap-odp.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapOdpDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                context: '*',
                objectName: '*'
            }
        }
    }
})
export class SapOdpDatasetAdapter extends TabularTypeDatasetAdapter<SapOdpDataset, Model.DatasetResource> {
    protected model(): IModel {
        return SapOdpDataset.MODEL;
    }

    protected getSchemaAlias(): string {
        return 'context';
    }

    protected async _toResource(dataset: SapOdpDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, this.model().name, undefined, this.getSchemaAlias(), 'objectName');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SapOdpDataset): Promise<SapOdpDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, this.model(), undefined, this.getSchemaAlias(), 'objectName');
    }
}
